module.exports = __webpack_public_path__ + "static/media/icons - Search.19f9e9b9.svg";